module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c3",
    attrs: {
      "id": "calibre_pb_2"
    }
  }, [_c('span', {
    staticClass: "c4"
  }, [_vm._v("Table of contents")])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('a', {
    attrs: {
      "id": "AuthorTOC"
    }
  }, [_c('span', {
    staticClass: "c5"
  })]), _c('a', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_006#ch1"
    }
  }, [_vm._v("Chapter 1: The Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_007#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Black Madness")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_008#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: A Long Walk")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_009#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Hour Of The Wolf")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_010#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Destroyer Of Worlds")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_011#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Bullets And Second Chances")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_012#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Pandora Protocol")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_013#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Turning Wheels And Necessary Evils")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_014#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Hunt, The Kill, And The\nExecution")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_015#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Edward's Worth")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_016#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Dead Collect Debts")])])]), _vm._v(" "), _c('p', {
    staticClass: "western"
  }, [_c('span', {
    staticClass: "c5"
  }, [_c('span', {
    attrs: {
      "href": "#/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_017#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Across The Threshold")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1225e0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_003.vue
// module id = 66
// module chunks = 0